import { render, staticRenderFns } from "./paymentGatewayTransactions.vue?vue&type=template&id=04597b41&scoped=true&"
import script from "./paymentGatewayTransactions.vue?vue&type=script&lang=js&"
export * from "./paymentGatewayTransactions.vue?vue&type=script&lang=js&"
import style0 from "./paymentGatewayTransactions.vue?vue&type=style&index=0&id=04597b41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04597b41",
  null
  
)

export default component.exports